var service = {
    fetch: fetch
};

export default service;

function fetch(project) {
    if (!project) return;

    return Vue.http
        .get('projects/' + project.slug + '/leads/contributors?limit=10000')
        .then((res) => res.body);
}
